import {
  CardStatus,
  CardType,
  getCardStatusFromParam,
  getCardTypeFromParam,
} from "../_entities/card"
import {
  DATE_PERIODS,
  DATE_PERIOD_DEFAULT,
  DatePeriod,
} from "../_entities/date"

export const isConvertibleToInteger = (
  value: string | string[] | undefined
): boolean => {
  return (
    typeof value === "string" &&
    typeof Number(value) === "number" &&
    Number.isInteger(Number(value))
  )
}

export const isConvertibleToDatePeriod = (
  value: string | string[] | undefined
): DatePeriod => {
  if (typeof value === "object") {
    return DATE_PERIODS[value.toString()]
  } else if (typeof value === "undefined") {
    return DATE_PERIOD_DEFAULT
  } else {
    return DATE_PERIODS[value]
  }
}

export const isConvertibleToCardType = (
  value: string | string[] | undefined
): CardType[] | undefined => {
  if (typeof value === "string") {
    return value
      .split(",")
      .filter(v => v !== "")
      .map(v => getCardTypeFromParam(v.trim())) as CardType[]
  } else if (typeof value === "undefined") {
    return undefined
  } else {
    return value.map(value => value.trim()) as CardType[]
  }
}

export const isConvertibleToCardStatus = (
  value: string | string[] | undefined
): CardStatus[] | undefined => {
  if (typeof value === "string") {
    return value
      .split(",")
      .filter(v => v !== "")
      .map(v => getCardStatusFromParam(v.trim())) as CardStatus[]
  } else if (typeof value === "undefined") {
    return undefined
  } else {
    return value.map(value => value.trim()) as CardStatus[]
  }
}
